import { BrowserProvider, formatEther } from "ethers";
import { AcctPermission } from "interfaces";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setWalletAddress, setWalletAmount } from "store/slices";
import { showFirstLastChar } from "utils";
import ls from "utils/secureStorage";

export const useWallet = () => {
  const dispatch = useDispatch();
  const [provider, setProvider] = useState<any>();

  const [amount, setAmount] = useState("");
  const [address, setAddress] = useState("");
  const [haveMetamask, sethaveMetamask] = useState(true);
  const [isConnected, setIsConnected] = useState(false);

  const getAccounts = useCallback(
    async (ethAddress: string[]) => {
      try {
        const nProvider = new BrowserProvider(window.ethereum);
        setProvider(nProvider);

        if (ethAddress) {
          dispatch(setWalletAddress(ethAddress[0]));
          setAddress(ethAddress[0]);

          const balance = await nProvider?.getBalance(ethAddress[0]);

          const formattedBalance = (balance && formatEther(balance!)) as string;
          dispatch(setWalletAmount(formattedBalance));

          setAmount(formattedBalance);
        }
      } catch (error) {}
    },
    [dispatch]
  );

  const [chainId, setChainId] = useState("");

  useMemo(async () => {
    const { ethereum } = window;
    const ethAddress = (await ethereum?.request!({
      method: "eth_requestAccounts",
    })) as string[];

    const chainId = await window.ethereum!.request({
      method: "eth_chainId",
    });

    setChainId(chainId);

    getAccounts(ethAddress);

    const handleAccountsChanged = (accounts: string[]) => {
      console.log(accounts, "the accounts");
      getAccounts(accounts);
    };

    const refreshChain = (chainId: string) => {
      setChainId(chainId);
      getAccounts(ethAddress);
    };

    if (typeof window !== "undefined") {
      ethereum.on("accountsChanged", handleAccountsChanged);
      ethereum.on("chainChanged", refreshChain);

      return () => {
        ethereum.removeListener("accountsChanged", handleAccountsChanged);
        ethereum.removeListener("chainChanged", refreshChain);
      };
    }

    if (chainId) {
      console.log("NEW UPDATE");
      getAccounts(ethAddress);
    }
  }, [getAccounts]);

  const handleConnectWallet = async () => {
    const { ethereum } = window;

    try {
      if (!ethereum) {
        sethaveMetamask(false);
      }

      const accountsPermission = (await ethereum.request({
        method: "wallet_requestPermissions",
        params: [{ eth_accounts: {} }],
      })) as AcctPermission["response"];

      const parentCapability = accountsPermission.find(({ parentCapability }) => parentCapability === "eth_accounts");

      if (parentCapability) {
        const accounts = (await ethereum?.request!({
          method: "eth_requestAccounts",
        })) as string[];

        const shortAddress = showFirstLastChar(accounts[0], 6);
        ls.set("cico_address", shortAddress);

        setIsConnected(true);
      }

      window.location.reload();
    } catch (error) {
      setIsConnected(false);
    }
  };

  useEffect(() => {
    const { ethereum } = window;

    const checkMetamaskAvailability = async () => {
      if (!ethereum) {
        sethaveMetamask(false);
      } else {
        const provider = new BrowserProvider(window.ethereum);
        setProvider(provider);
        sethaveMetamask(true);
      }
    };
    checkMetamaskAvailability();

    const cico_address = ls.get("cico_address");

    cico_address ? setIsConnected(true) : setIsConnected(false);

    return () => {
      // window.ethereum?.removeListener("accountsChanged", refreshAccounts);
    };
  }, []);

  return {
    provider,
    amount,
    setAmount,
    address,
    isConnected,
    setIsConnected,
    sethaveMetamask,
    haveMetamask,
    handleConnectWallet,
    chainId,
  };
};

// CELO = '0xaef3'
// ETH = '0x1'
